import { useTranslation } from 'react-i18next';

import { MAP_REPORT_CONFIG } from '../lib/map-layers.config';
import { MAP_REPORTS } from '../model/types';

/** Legacy's bottom-left legend of the four marker slices (`mapping.js:122-144`). */
export function MapLegend() {
  const { t } = useTranslation();

  return (
    <ul className="flex flex-col gap-1">
      {MAP_REPORTS.map((report) => (
        <li key={report} className="flex items-center gap-2 text-xs">
          <span
            className="h-3 w-3 shrink-0 rounded-full"
            style={{ backgroundColor: MAP_REPORT_CONFIG[report].color }}
          />
          {t(MAP_REPORT_CONFIG[report].labelKey)}
        </li>
      ))}
    </ul>
  );
}
